import React from 'react';

const steps = [
    {
        icon: 'bi-search',
        title: 'Find a Doctor',
        desc: 'Search by specialty, name, or availability to find the right expert for you.'
    },
    {
        icon: 'bi-calendar-check',
        title: 'Book Appointment',
        desc: 'Select a suitable time slot and book your appointment instantly.'
    },
    {
        icon: 'bi-camera-video',
        title: 'Video Consult',
        desc: 'Connect securely with your doctor via high-quality video call.'
    },
    {
        icon: 'bi-clipboard-pulse',
        title: 'Get Prescription',
        desc: 'Receive digital prescriptions and medical advice immediately after the call.'
    }
];

const HowItWorks = () => {
    return (
        <section id="features" className="py-4 bg-white">
            <div className="container py-5">
                <div className="text-center mb-5">
                    <span className="text-primary fw-bold small text-uppercase spacing-2">Easy Process</span>
                    <h2 className="fw-bold mt-2">How It Works</h2>
                </div>

                <div className="row g-4 position-relative">
                    {/* Connecting Line (Desktop Only) */}
                    <div className="d-none d-lg-block position-absolute top-50 start-0 w-100 border-top border-dashed border-secondary opacity-25" style={{ zIndex: 0 }}></div>

                    {steps.map((step, idx) => (
                        <div key={idx} className="col-lg-3 col-sm-6 position-relative" style={{ zIndex: 1 }}>
                            <div className="text-center bg-white p-3 h-100">
                                <div className="d-inline-flex align-items-center justify-content-center bg-primary text-white rounded-circle shadow-lg mb-4"
                                    style={{ width: '70px', height: '70px', fontSize: '1.5rem' }}>
                                    <i className={`bi ${step.icon}`}></i>
                                </div>
                                <h5 className="fw-bold mb-2">{step.title}</h5>
                                <p className="text-muted small mb-0">{step.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
